module.exports = __webpack_public_path__ + "img/AL801-1.3495bfc8.jpg";